(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    (function () {
    var boxes = 0;

    var money = function (amount) {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
      var value = Number(amount);
      if (!isFinite(value)) return String(amount || '');
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(value);
      } catch (error) {
        return value.toFixed(2);
      }
    };

    var bind = function (input) {
      if (input.dataset.predictiveReady) return;
      var container = input.closest('.header-search--fullwidth');
      var dropdown = container && container.querySelector('.header-predictive-dropdown');
      if (!dropdown) return;
      input.dataset.predictiveReady = '';
      var debounceTimer;
      var latest = 0;
      var active = -1;
      var status = container.querySelector('[data-predictive-status]');
      // The header can render this box twice (menu and drawer copies), so
      // the list's id is given here, unique per box.
      var listId = dropdown.id || (dropdown.id = 'HeaderPredictiveList-' + ++boxes);

      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', listId);
      input.setAttribute('aria-expanded', 'false');

      var setActive = function (index) {
        var options = dropdown.children;
        for (var i = 0; i < options.length; i++) options[i].setAttribute('aria-selected', i === index ? 'true' : 'false');
        active = index;
        if (index < 0) {
          input.removeAttribute('aria-activedescendant');
        } else {
          input.setAttribute('aria-activedescendant', options[index].id);
          options[index].scrollIntoView({ block: 'nearest' });
        }
      };

      var show = function (open) {
        dropdown.hidden = !open;
        input.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) setActive(-1);
      };

      var close = function () {
        show(false);
        dropdown.replaceChildren();
      };

      var announce = function (text) {
        if (status) status.textContent = text;
      };

      // Fills [count] and [query] in the theme's sentences. Functions, not
      // strings, as the replacement: a typed "$&" must stay as typed.
      var sentence = function (template, count, query) {
        return (template || '')
          .replace('[count]', function () { return String(count); })
          .replace('[query]', function () { return query; });
      };

      var row = function (product, index) {
        var link = document.createElement('a');
        link.className = 'header-predictive-item';
        link.id = listId + '-option-' + index;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        // Reached with the arrow keys from the box, not with Tab.
        link.tabIndex = -1;
        link.href = /^\/(?!\/)/.test(product.url || '') ? product.url : '#';
        var imageUrl = product.featured_image && product.featured_image.url;
        var picture;
        if (imageUrl) {
          picture = document.createElement('img');
          picture.src = imageUrl + (imageUrl.indexOf('?') === -1 ? '?' : '&') + 'width=80';
          picture.alt = '';
          picture.width = 40;
          picture.height = 40;
          picture.loading = 'lazy';
        } else {
          // No photo: keep the space so the titles still line up.
          picture = document.createElement('span');
          picture.setAttribute('aria-hidden', 'true');
        }
        picture.className = 'header-predictive-img';
        var title = document.createElement('span');
        title.className = 'header-predictive-title';
        title.textContent = product.title || '';
        var price = document.createElement('span');
        price.className = 'header-predictive-price';
        price.textContent = product.price != null ? money(product.price) : '';
        link.append(picture, title, price);
        return link;
      };

      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        setActive(-1);
        var query = input.value.trim();
        if (query.length < 2) {
          latest++;
          close();
          announce('');
          return;
        }
        debounceTimer = setTimeout(function () {
          var request = ++latest;
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
            .then(function (res) {
              return res.json();
            })
            .then(function (data) {
              // A slower, older reply must not replace newer results.
              if (request !== latest) return;
              var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
              if (!products.length) {
                close();
                if (status) announce(sentence(status.dataset.none, 0, query));
                return;
              }
              dropdown.replaceChildren.apply(dropdown, products.map(row));
              show(true);
              if (status) announce(sentence(status.dataset.found, products.length, query));
            })
            .catch(function () {
              if (request === latest) close();
            });
        }, 250);
      });

      document.addEventListener('click', function (event) {
        if (!(event.target instanceof Element) || !container.contains(event.target)) show(false);
      });

      // Keyboard: leaving the box and its results closes them.
      container.addEventListener('focusout', function (event) {
        if (!(event.relatedTarget instanceof Node) || !container.contains(event.relatedTarget)) show(false);
      });

      input.addEventListener('keydown', function (event) {
        var options = dropdown.children;

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          if (!options.length) return;
          event.preventDefault();
          var down = event.key === 'ArrowDown';
          if (dropdown.hidden) {
            // Closed with Escape (or a click away): the arrows reopen it.
            show(true);
            setActive(down ? 0 : options.length - 1);
            return;
          }
          // -1 is the box itself: past either end the highlight goes back
          // to what the shopper typed.
          var next = active + (down ? 1 : -1);
          if (next >= options.length) next = -1;
          if (next < -1) next = options.length - 1;
          setActive(next);
          return;
        }

        if (event.key === 'Enter') {
          // Nothing highlighted: Enter searches, as it always has.
          if (dropdown.hidden || active < 0 || !options[active]) return;
          event.preventDefault();
          options[active].click();
          return;
        }

        if (event.key !== 'Escape' || dropdown.hidden) return;
        // Close the results but keep the shopper where they are; it used to
        // blur the box, dropping keyboard focus to the start of the page.
        event.preventDefault();
        show(false);
      });
    };

    document.querySelectorAll('.header-predictive-input').forEach(bind);
  })();
  } catch(e) { console.error(e); }
})();

})();
